<template>
  <div class="travelCategory">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent"
              @click="showModal(null)"
            >
              新增分類
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3 table-top-bar">
        <div class="card-body p-0">
          <div class="input-group">
            <span class="input-group-text d-none d-sm-block">
              顯示第
              {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
              {{
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage
              }}
              項結果，共 {{ totalRows }} 項
            </span>
            <input
              v-model="filter"
              type="text"
              class="form-control"
              placeholder="搜尋"
            />
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <b-table
            :responsive="windowWidth > breakpoints.sm"
            :stacked="windowWidth <= breakpoints.sm"
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(img_url)="data">
              <div class="d-flex">
                <div class="imgBox" style="width: 100px">
                  <div class="imgBox-inner">
                    <div class="imgBox-fit">
                      <img
                        v-if="data.item.img_url"
                        :src="data.item.img_url"
                        :alt="data.item.name + '圖片'"
                      />
                      <i v-else class="bi bi-image"></i>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:cell(active)="data">
              <div class="d-flex flex-nowrap flex align-items-center">
                <button
                  @click="showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="編輯"
                >
                  <i class="bi bi-pencil mx-1 fs-5"></i>
                </button>
                <router-link
                  custom
                  v-slot="{ navigate }"
                  :to="{
                    name: 'TravelCategorySub',
                    params: { id: data.item.id }
                  }"
                >
                  <button
                    @click="navigate"
                    type="button"
                    class="btn btn-link px-1"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="子分類"
                  >
                    <i class="bi bi-folder"></i>
                  </button>
                </router-link>
                <button
                  v-if="
                    !data.item.sub_category_count && !data.item.itinerary_count
                  "
                  @click="showDeleteModal(data.item.id, data.item.name)"
                  type="button"
                  class="btn btn-link px-1 text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="刪除"
                >
                  <i class="bi bi-trash me-2"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-block d-sm-none text-center mb-3">
        顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
        {{
          currentPage == 1
            ? totalRows > perPage
              ? perPage
              : totalRows
            : perPage * (currentPage - 1) + perPage > totalRows
            ? totalRows
            : perPage * (currentPage - 1) + perPage
        }}
        項結果，共 {{ totalRows }} 項
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="right"
        first-number
        last-number
        class="mb-sm-0 mb-3 mt-sm-0 mt-3"
      ></b-pagination>
    </div>
    <div
      class="modal fade"
      id="travelCategoryModal"
      tabindex="-1"
      ref="travelCategoryModal"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" v-if="modalDate">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEdit ? '編輯分類' : '新增分類' }}</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="save">
              <div class="mb-3">
                <label for="modalTitle" class="form-label required"
                  >分類名稱</label
                >
                <input
                  v-model="modalDate.name"
                  type="text"
                  class="form-control"
                  id="modalTitle"
                  placeholder="請輸入"
                  required
                  :class="{ 'is-invalid': errMsg && errMsg.name }"
                />
                <div class="invalid-feedback" v-if="errMsg && errMsg.name">
                  {{ errMsg.name }}
                </div>
              </div>
              <div class="mb-3">
                <label for="modalStaticUri" class="form-label">自定網址</label>
                <input
                  v-model="modalDate.static_uri"
                  type="text"
                  class="form-control"
                  id="modalStaticUri"
                  placeholder="請輸入"
                  :class="{ 'is-invalid': errMsg && errMsg.static_uri }"
                  pattern="[0-9a-z\-_]+"
                />
                <div class="form-text">
                  只能用英文小寫、數字及'-'、'_'符號(非字首)，不可有空白 <br />
                  用於強化 SEO 搜尋
                </div>
                <div
                  class="invalid-feedback"
                  v-if="errMsg && errMsg.static_uri"
                >
                  自定網址已重複
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">首頁分類圖</label>
                <div class="imgBox-has-close" style="max-width: 130px">
                  <button
                    v-if="modalDate.img_url"
                    @click="removeImage"
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                  />
                  <label
                    for="imageFile"
                    class="imgBox w-100"
                    style="cursor: pointer"
                  >
                    <div class="imgBox-inner">
                      <div class="imgBox-fit">
                        <img
                          v-if="modalDate.img_url"
                          :src="modalDate.img_url"
                          :alt="modalDate.name"
                        />
                        <i v-else class="bi bi-image"></i>
                      </div>
                    </div>
                  </label>
                </div>
                <div class="form-text">
                  圖片格式：JPG、PNG，建議尺寸： 130 x 96 px
                </div>
                <input
                  class="form-control d-none"
                  type="file"
                  id="imageFile"
                  ref="imageFile"
                  accept="image/png, image/jpeg"
                  @change="onFileChange($event.target)"
                  :class="{ 'is-invalid': invalid.img_url }"
                />
                <div class="invalid-feedback" v-show="invalid.small_img">
                  {{ invalid.small_img }}
                </div>
              </div>
              <button ref="submit" type="submit" class="d-none"></button>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button
              @click="$refs.submit.click()"
              type="button"
              class="btn btn-primary"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal
      name="行程分類"
      :deleteItem="deleteItem"
      @confirmDelete="deleteEvent"
    />
  </div>
</template>

<script>
import { travel } from '@/http/api/travel.js'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { Modal } from 'bootstrap'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import DeleteModal from '@/components/modal/DeleteModal.vue'

const defaultModalDate = {
  name: null,
  static_uri: null,
  img_url: null
}

export default {
  name: 'TravelCategory',
  components: {
    Title,
    Breadcrumb,
    DeleteModal
  },
  data () {
    return {
      bootstrap_modal: null,
      categoryTravel: null,
      currentPage: 1,
      deleteItem: '',
      errMsg: null,
      errMsgKey: {
        name: '分類名稱',
        static_uri: '自訂網址',
        img_url: '分類圖片'
      },
      filter: null,
      filterOn: ['name', 'itinerary_count', 'sub_category_count', 'static_uri'],
      fields: [
        {
          key: 'name',
          label: '分類名稱',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'img_url',
          label: '首頁分類圖',
          class: 'align-middle'
        },
        {
          key: 'sub_category_count',
          label: '子分類數量',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'itinerary_count',
          label: '行程數量',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'static_uri',
          label: '自定網址',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'active',
          label: '功能',
          class: 'align-middle'
        }
      ],
      isEdit: false,
      items: null,
      invalid: {
        img_url: null
      },
      modalID: null,
      modalDate: JSON.parse(JSON.stringify(defaultModalDate))
    }
  },
  computed: {
    ...mapState([
      'token',
      'windowWidth',
      'breakpoints',
      'perPage',
      'totalRows'
    ]),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.getData()
      }
    },
    currentPage () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    items () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'InitBootstrapTooltip',
      'Loading',
      'Loaded',
      'SetRouterName',
      'SetTotalRows',
      'SetErrMsg',
      'SetErrMsgKey',
      'ToggleDeleteModal'
    ]),
    ...mapActions(['uploadImage']),
    createCategory () {
      const vm = this
      travel
        .createCategory(vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '創建資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteEvent () {
      const vm = this
      travel
        .deleteCategory(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '刪除資料成功'
            })
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
    },
    getData () {
      const vm = this
      const config = { ...vm.token }
      config.params = {
        parent_id: 0
      }
      travel
        .getCategory('', config)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) =>
              Date.parse(a.created_at).valueOf() >
              Date.parse(b.created_at).valueOf()
                ? -1
                : 1
            )
            vm.SetTotalRows(vm.items.length)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    getTravel () {
      const vm = this
      travel
        .getCategory(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.categoryTravel = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    onFiltered (filteredItems) {
      const vm = this
      vm.SetTotalRows(filteredItems.length)
      vm.currentPage = 1
    },
    onFileChange (event) {
      const vm = this
      vm.uploadImage(event).then((value) => {
        if (value) {
          vm.modalDate.img_url = value
        }
      })
    },
    removeImage () {
      this.modalDate.img_url = null
    },
    showModal (id) {
      const vm = this
      vm.bootstrap_modal = new Modal(vm.$refs.travelCategoryModal, {
        backdrop: 'static',
        keyboard: false
      })
      vm.modalID = id
      vm.isEdit = false
      if (!id) {
        vm.modalDate = JSON.parse(JSON.stringify(defaultModalDate))
        vm.bootstrap_modal.show()
        return
      }
      vm.isEdit = true
      vm.Loading()
      travel
        .getCategory(id, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.modalDate = data.data
            vm.bootstrap_modal.show()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    showDeleteModal (id, title) {
      const vm = this
      vm.modalID = id
      vm.deleteItem = title
      vm.ToggleDeleteModal(true)
    },
    save () {
      const vm = this
      vm.Loading()
      if (vm.isEdit) {
        vm.updateCategory()
        return
      }
      vm.createCategory()
    },
    updateCategory () {
      const vm = this
      travel
        .updateCategory(vm.modalID, vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
    }
  }
}
</script>
